import axios from 'axios';
import { Toast, Indicator } from "mint-ui";
axios.defaults.timeout = 10000;//响应时间 
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  return config
}, function (error) {
  Toast({
    message:'请求超时',
    position: "bottom"
  })
  return Promise.reject(error)
});
// 添加响应拦截器
axios.interceptors.response.use(
  response => {
    Indicator.close()
    if (response.data) {
      if (response.data.Code == 0) {
        return response.data.Data;
      
      } else if (response.config.url.indexOf('/api/bind') != -1 && response.data.Code == 409) {
        Toast({
          message: '手机号已被使用,如有疑问，请联系客服',
          position: "bottom"
        })
      } else if (response.config.url.indexOf('/api/bind') != -1 && response.data.Code == 403) {
        Toast({
          message: '验证码不正确',
          position: "bottom"
        })
      } else if (response.config.url.indexOf('/api/phonebind') != -1 && response.data.Code == 409) {
        Toast({
          message: '该用户已绑定手机号或该手机号已被使用, 请联系客服',
          position: "bottom"
        })
      }else if (response.config.url.indexOf('/api/phonebind') != -1 && response.data.Code == 403) {
        Toast({
          message: '验证码不正确',
          position: "bottom"
        })
      } else if (response.config.url.indexOf('/api/login/code') != -1 && response.data.Code == 403) {
        Toast({
          message: '验证码不正确',
          position: "bottom"
        })
      } else if (response.config.url.indexOf('/api/login/token') != -1 && response.data.Code == 403) {
        Toast({
          message: '登录失效, 请重新登录',
          position: "bottom"
        })
      } else if (response.config.url.indexOf('/api/userinfo') != -1 && response.data.Code == 404) {
        Toast({
          message: '用户信息不存在',
          position: "bottom"
        })
      } else if (response.config.url.indexOf('/api/userinfo') != -1 && response.data.Code == 406) {
        Toast({
          message: '身份证号码格式不正确',
          position: "bottom"
        })
      } else if (response.config.url.indexOf('/api/userinfo') != -1 && response.data.Code == 409) {
        Toast({
          message: '该身份证已被使用',
          position: "bottom"
        })
      } else if (response.config.url.indexOf('/api/user/detail') != -1 && response.data.Code == 404) {
        Toast({
          message: '用户信息不存在',
          position: "bottom"
        })
      } else if (response.config.url.indexOf('/api/userid/openid') != -1 && response.data.Code == 404) {
        Toast({
          message: '用户信息不存在',
          position: "bottom"
        })
      } else if (response.data.Code == 400) {
        Toast({
          message: '参数错误',
          position: "bottom"
        })
      } else if (response.data.Code == 401) {
        // let ReUrl = window.location.href;
        // router.push({
        //   path: '/user', query: {
        //     ReUrl: ReUrl,
        //     RegType:2
        //   }
        // })
        // return;

      } else if (response.data.Code == 423) {
        Toast({
          message: '该用户已被冻结, 请联系客服处理',
          position: "bottom"
        })
       } else if (response.data.Code == 500) {
        Toast({
          message: '服务器内部错误',
          position: "bottom"
        })
      } else if (response.data.code == 1) {
        Toast({
          message: response.data.msg,
          position: "bottom"
        })
        return Promise.reject(response.data.data);
      } else {
        Toast({
          message: response.data.Message,
          position: "bottom"
        })
      }
      return Promise.reject(response.data);
    }
    return response;
  },
  error => {
    Indicator.close()
      Toast({
        message: '网络开了点小差～',
        position: "bottom",
      })
      return Promise.reject(error.response)
  });



// WEBPACK FOOTER //
// ./src/service/config.js